import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/gossip";

export default function TopicBoard() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8 lg:px-12">
        <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-apps-2-fill" aria-hidden="true"></i>
              按需取瓜
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              主题大盘点 · 四大频道
            </h2>
          </div>
          <p className="mt-2 max-w-md text-sm text-foreground-500 md:mt-0 md:text-right">
            想吃哪块的瓜，就进哪个频道，专区内合集与讨论按热度持续滚动更新。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, idx) => {
            const cover = articles.find((a) => a.category === cat.slug)?.image;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative block overflow-hidden rounded-2xl border border-background-200/70 bg-background-50"
              >
                <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
                  {cover && (
                    <img
                      src={cover}
                      alt={`${cat.name}合集`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {cat.name}
                    </h3>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-700">
                      {cat.count} 篇
                    </span>
                  </div>
                  <p className="mt-0.5 text-sm font-semibold text-primary-600">{cat.tagline}</p>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {cat.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold whitespace-nowrap text-foreground-700 transition-colors group-hover:text-primary-600">
                    进入频道
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                  </span>
                </div>
                <span className="pointer-events-none absolute right-4 top-3 font-heading text-5xl font-black text-primary-500/15">
                  0{idx + 1}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}